import { InboxLayout, InstagramIcon } from '@/components/shared-inbox';
import type { InboxPlatformConfig, InboxStore } from '@/components/shared-inbox';
import { useInstagramInboxStore } from '@/stores/useInstagramInboxStore';
import { instagramInboxHooks } from '@/api/instagramInboxAdapters';

const PLATFORM_CONFIG: InboxPlatformConfig = {
    name: 'instagram',
    label: 'Instagram',
    icon: InstagramIcon,
    searchPlaceholder: 'Search by username, name, business...',
    windowExpiredText: '24h messaging window expired. The user must message you first to reopen.',
    resumeAiBtnVariant: 'green',
};

export function InstagramInbox() {
    const raw = useInstagramInboxStore();

    const store: InboxStore = {
        selectedConversationId: raw.selectedConversationId,
        showAgentConfig: raw.showAgentConfig,
        setSelectedConversationId: raw.setSelectedConversation,
        clearSelectedConversationId: raw.clearSelectedConversation,
        toggleAgentConfig: raw.toggleAgentConfig,
        setShowAgentConfig: raw.setShowAgentConfig,
    };

    return (
        <InboxLayout
            platform={PLATFORM_CONFIG}
            hooks={instagramInboxHooks}
            store={store}
        />
    );
}
